function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

$(function() {
    if (cookiesPopup) {
        if (!getCookie('cookies_popup')) {
            console.log(1);
            $('.cookies-popup').addClass('is-visible');

            setCookie('cookies_popup', 1, 30);
        }
    }

    $('.cookies-popup').on('click', 'a', function(e) {
        e.preventDefault();

        $('.cookies-popup').removeClass('is-visible');
    });
});

